import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import './Logo.css';

const Logo = ({ className = '' }) => {
  const { theme } = useTheme();

  return (
    <div className={`logo-container ${className}`} data-theme={theme}>
      <img 
        src="/logo.svg" 
        alt="ArmaRayan Logo" 
        className="logo-svg"
      />
    </div>
  );
};

export default Logo;

